import React from 'react';
import { istRangeForPreset } from '../utils/istDate';

const DateRangeFilter = ({ 
  dateFilter, 
  setDateFilter, 
  startDate, 
  setStartDate, 
  endDate, 
  setEndDate,
  label = "Date Range"
}) => {
  const handleFilterChange = (value) => {
    setDateFilter(value);
    const range = istRangeForPreset(value);
    if (range !== null) {
      setStartDate(range.start_date);
      setEndDate(range.end_date);
    }
    // 'custom' returns null → preserve whatever the user has already picked
  };

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>
        <select
          value={dateFilter}
          onChange={(e) => handleFilterChange(e.target.value)}
          className="input-base min-w-[140px]"
          data-testid="date-filter-select"
        >
          <option value="all">All Time</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="tomorrow">Tomorrow</option>
          <option value="last7days">Last 7 Days</option>
          <option value="mtd">MTD</option>
          <option value="last30days">Last 30 Days</option>
          <option value="custom">Custom Range</option>
        </select>
      </div>
      
      {dateFilter === 'custom' && (
        <>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">From</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="input-base"
              data-testid="start-date"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">To</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="input-base"
              data-testid="end-date"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default DateRangeFilter;
